/**
 * The bar across the top of a portal an agent is looking at.
 *
 * It has to be impossible to forget you are in here. An agent reading a
 * statement and thinking it is their own screen would misread every figure
 * on it, and one who forgets would eventually try to reply to a message as
 * the athlete. So: always visible, names whose portal this is, says plainly
 * that nothing can be changed, and offers the way out.
 */

import { useNavigate } from 'react-router-dom'
import { previewState, exitPreview } from '../api/clientPortal/previewMode'
import styles from './PortalPreviewBanner.module.css'

export default function PortalPreviewBanner() {
  const navigate = useNavigate()
  const preview = previewState()
  if (!preview) return null

  const who = preview.user.name || preview.user.email || 'this client'

  function leave() {
    const clientId = preview!.user.client_id
    exitPreview()
    navigate(clientId ? `/clients/${clientId}` : '/clients')
  }

  return (
    <div className={styles.bar} role="status">
      <span className={styles.label}>Preview</span>
      <span className={styles.text}>
        You are seeing <strong>{who}</strong>&rsquo;s portal exactly as they see it.
        Nothing here can be changed.
      </span>
      <button type="button" onClick={leave} className={styles.exit}>
        Leave preview
      </button>
    </div>
  )
}
